class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
		gsap.set('.s-mv', {
			autoAlpha: 1,
		});
		
		ScrollTrigger.create({
			trigger: '.s-bg-white',
			start: 'center center',
			onEnter: () => {
				gsap.set('.s-mv', {
					autoAlpha: 0,
				});
			},
			onLeaveBack: () => {
				gsap.set('.s-mv', {
					autoAlpha: 1,
				});
			},
		});

		const mvCopy = document.querySelector('.js-mv-copy');
		const header = document.querySelector('.js-header');
		const mvScroll = document.querySelector('.js-mv-scroll');
	
		if (!mvCopy) return;
	
		// =========================
		// 初期状態
		// =========================
		gsap.set($('.p-top'), {
			opacity: 0,
		});
		gsap.set(mvCopy, {
			opacity: 0,
			x: '-3rem',
			filter: 'blur(1.5rem)',
			clipPath: 'inset(0 100% 0 0)',
		});
	
		gsap.set([header, mvScroll], {
			opacity: 0,
		});
	
		// =========================
		// アニメーション
		// =========================
		const tl = gsap.timeline();
	
		tl.to($('.p-top'), {
			opacity: 1,
			duration: 0.7,
			ease: 'power2.out',
		});
		tl.to(mvCopy, {
			opacity: 1,
			x: 0,
			filter: 'blur(0rem)',
			clipPath: 'inset(0 0% 0 0)',
			duration: 1.5,
			ease: 'power3.out',
		})
		.to([header, mvScroll], {
			opacity: 1,
			duration: 0.7,
			ease: 'power2.out',
		}, '+=0.05');

		const caseSplideEl = document.querySelector('.js-case-splide');

		if (caseSplideEl) {
			const progressBar = document.querySelector('.s-case-head__nav .line span');
			const prevBtn = document.querySelector('.js-case-prev');
			const nextBtn = document.querySelector('.js-case-next');

			const splide = new Splide(caseSplideEl, {
				type: 'loop',
				autoWidth: true,
				gap: '1.6rem',
				focus: 'center',
				arrows: false,
				pagination: false,
				trimSpace: false,
				breakpoints: {
					768: {
						gap: '2rem',
					},
				},
			});

			const updateProgress = () => {
				if (!progressBar) return;

				const total = splide.length;
				if (total <= 0) return;

				const current = splide.index + 1;
				progressBar.style.width = `${(current / total) * 100}%`;
			};

			splide.on('mounted move', updateProgress);
			splide.mount();

			prevBtn?.addEventListener('click', () => splide.go('<'));
			nextBtn?.addEventListener('click', () => splide.go('>'));
		}
	
	
	}
}